import OrderEditViewStore from '@components/order/stores/OrderEditViewStore';
import { Box } from '@mui/system';
import { observer } from 'mobx-react-lite';
import React from 'react';
import OrderLiveStatusIcon from './OrderLiveStatusIcon';
import OrderStatusInfo from './status-text/OrderStatusInfo';

interface OrderLiveStatusProps {
    orderEditViewStore: OrderEditViewStore;
}

const OrderLiveStatus: React.FC<OrderLiveStatusProps> = observer(({ orderEditViewStore }) => {
    const { insertedOrder } = orderEditViewStore;

    if (insertedOrder === undefined) {
        return null;
    }

    return (
        <Box flexGrow={1} p={2} display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
            <OrderLiveStatusIcon order={insertedOrder} />

            <Box mt={6} display={"flex"} flexDirection={"column"} gap={2}>
                <OrderStatusInfo orderEditViewStore={orderEditViewStore} />
            </Box>
        </Box>
    )
})

export default OrderLiveStatus;